import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { Icon } from "@blueprintjs/core";
import ToolbarItem from "./ToolbarItem";
import { connectToEditor } from "../withEditorProps";
export default connectToEditor((editorState) => {
  return {
    disabled: !(editorState.sequenceDataHistory && editorState.sequenceDataHistory.future && editorState.sequenceDataHistory.future.length)
  };
})(({ toolbarItemProps, redo, disabled }) => {
  return /* @__PURE__ */ jsx(
    ToolbarItem,
    {
      ...{
        Icon: /* @__PURE__ */ jsx(Icon, { "data-test": "veRedoTool", icon: "redo" }),
        disabled,
        onIconClick: redo,
        tooltip: /* @__PURE__ */ jsxs("span", { children: [
          "Redo",
          " ",
          /* @__PURE__ */ jsx("span", { style: { fontSize: 10 }, children: "(Cmd/Ctrl+Shift+Z or Cmd/Ctrl+Y)" })
        ] }),
        ...toolbarItemProps
      }
    }
  );
});
